module.exports = __webpack_public_path__ + "img/74.381ccb7a.png";